var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4221_53054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5966 9.86849L19.9038 18.3646C19.9451 18.6336 19.9277 18.9083 19.853 19.1699C19.7782 19.4316 19.6478 19.674 19.4706 19.8805C19.2934 20.0871 19.0737 20.2529 18.8265 20.3667C18.5793 20.4804 18.3104 20.5394 18.0383 20.5396H5.44716C5.17503 20.5394 4.90616 20.4804 4.65895 20.3667C4.41174 20.2529 4.19203 20.0871 4.01487 19.8805C3.8377 19.674 3.70727 19.4316 3.6325 19.1699C3.55773 18.9083 3.54039 18.6336 3.58166 18.3646L4.88884 9.86849C4.95751 9.4229 5.18333 9.01657 5.52546 8.72296C5.8676 8.42935 6.30349 8.26782 6.75434 8.26758H16.7311C17.182 8.26782 17.6179 8.42935 17.96 8.72296C18.3022 9.01657 18.528 9.4229 18.5966 9.86849Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6294 5.43595C13.6358 5.18399 13.5917 4.9333 13.4997 4.69866C13.4077 4.46401 13.2696 4.25016 13.0937 4.06969C12.9177 3.88923 12.7075 3.74581 12.4752 3.64789C12.243 3.54996 11.9935 3.49951 11.7415 3.49951C11.4894 3.49951 11.2399 3.54996 11.0077 3.64789C10.7755 3.74581 10.5652 3.88923 10.3892 4.06969C10.2133 4.25016 10.0752 4.46401 9.98324 4.69866C9.89123 4.9333 9.84712 5.18399 9.85351 5.43595",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90271 14.8741H11.7343M14.5659 14.8741H11.7355M11.7355 14.8741V12.0425M11.7355 14.8741V17.7057",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4221_53054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrder);
export default __webpack_public_path__ + "static/media/ic-order.16b67c821e67b9d5f46de3f57c97fc1d.svg";
export { ForwardRef as ReactComponent };